import React, { useState } from 'react';
import { Plus, Settings, Compass, Gamepad2, Code2, Music, Palette, Users, Sparkles, Crown } from 'lucide-react';
import './ServerSidebar.css';

const defaultServers = [
  { id: 0, name: 'Direct Messages', icon: Users, color: '#d4a574' },
  { id: 1, name: 'Gaming Hub', icon: Gamepad2, color: '#f87171' },
  { id: 2, name: 'Dev Community', icon: Code2, color: '#60a5fa' },
  { id: 3, name: 'Music Lounge', icon: Music, color: '#a78bfa' },
  { id: 4, name: 'Art Gallery', icon: Palette, color: '#4ade80' },
];

const iconColors = ['#f87171', '#60a5fa', '#a78bfa', '#4ade80', '#fbbf24', '#ec4899', '#14b8a6'];

function ServerSidebar({ selectedServer, onSelectServer, onOpenSettings, servers = [], onCreateServer }) {
  const displayServers = servers.length > 0 ? servers : defaultServers;
  const [hoveredServer, setHoveredServer] = useState(null);

  const getServerIcon = (server) => {
    if (server.icon) {
      const IconComponent = server.icon;
      return IconComponent;
    }
    return null;
  };

  return (
    <div className="server-sidebar">
      <div className="server-list">
        {displayServers.map((server, index) => {
          const IconComponent = server.icon;
          const isActive = selectedServer === server.id;
          const serverColor = server.color || iconColors[index % iconColors.length];
          
          return (
            <div
              key={server.id}
              className={`server-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelectServer(server.id)}
              onMouseEnter={() => setHoveredServer(server.id)}
              onMouseLeave={() => setHoveredServer(null)}
            >
              <div className="server-pill" />
              <div 
                className="server-icon"
                style={{ 
                  '--server-color': serverColor,
                  background: isActive ? serverColor : 'var(--bg-elevated)'
                }}
              >
                {IconComponent ? (
                  <IconComponent size={20} style={{ color: isActive ? 'var(--bg-primary)' : serverColor }} />
                ) : (
                  <span style={{ color: isActive ? 'var(--bg-primary)' : serverColor, fontWeight: 700 }}>
                    {server.name[0].toUpperCase()}
                  </span>
                )}
              </div>
              <div className="server-tooltip">{server.name}</div>
            </div>
          );
        })}
        
        <div className="server-divider" />
        
        <div className="server-item action-item" onClick={onCreateServer}>
          <div className="server-pill" />
          <div className="server-icon add-server">
            <Plus size={20} />
          </div>
          <div className="server-tooltip">Create Server</div>
        </div>
        
        <div className="server-item action-item">
          <div className="server-pill" />
          <div className="server-icon explore-server">
            <Compass size={20} />
          </div>
          <div className="server-tooltip">Discover</div>
        </div>
      </div>
      
      <div className="server-bottom">
        <div 
          className="server-item action-item"
          onClick={onOpenSettings}
        >
          <div className="server-pill" />
          <div className="server-icon settings-icon">
            <Settings size={20} />
          </div>
          <div className="server-tooltip">Settings</div>
        </div>
      </div>
    </div>
  );
}

export default ServerSidebar;
